import { LegalLayout } from "@/components/SiteFooter";
import { Seo } from "@/components/Seo";

const ROWS = [
  ["access_token", "Essential", "Keeps you signed in with email/password", "15 minutes"],
  ["refresh_token", "Essential", "Renews your sign-in session securely", "7 days"],
  ["session_token", "Essential", "Keeps you signed in with Google", "7 days"],
  ["tl-theme (local storage)", "Preference", "Remembers light or dark mode", "Until cleared"],
  ["Google AdSense cookies (e.g. __gads, __gpi, IDE)", "Advertising", "Serve and measure ads, limit repeats, personalize ads where permitted", "Up to 13 months"],
  ["Plaid Link (only when linking)", "Essential", "Secure institution connection inside the Plaid window", "Session"],
];

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" updated="October 10, 2026">
      <Seo title="Cookie Policy" description="Which cookies and local storage PillarWealth.io uses, including sign-in, preference and Google AdSense cookies." path="/cookies" />
      <p>Cookies are small text files stored by your browser. We use a few to keep you signed in and remember your settings, and our advertising partner Google uses some to show ads.</p>
      <h2>Cookies we use</h2>
      <table data-testid="cookies-table">
        <thead><tr><th>Name</th><th>Type</th><th>Purpose</th><th>Duration</th></tr></thead>
        <tbody>{ROWS.map((r) => <tr key={r[0]}>{r.map((c) => <td key={c}>{c}</td>)}</tr>)}</tbody>
      </table>
      <h2>Essential cookies</h2>
      <p>Sign-in cookies are HTTP-only and secure, so page scripts cannot read them. The app cannot keep you signed in without them.</p>
      <h2>Advertising cookies</h2>
      <p>Google AdSense shows ads on content pages such as the Content Hub, daily market recaps and calculators. If you choose "Accept all", ads may be personalized; if you choose "Essential only", Google is asked to show non-personalized ads (which may still use cookies for frequency capping, fraud prevention and measurement). You can change your choice with the "Cookie settings" link in the footer, turn off personalized ads at <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">adssettings.google.com</a> or visit <a href="https://www.aboutads.info/choices" target="_blank" rel="noopener noreferrer">aboutads.info</a>.</p>
      <h2>Managing cookies</h2>
      <p>You can block or delete cookies in your browser settings. Blocking essential cookies will sign you out and stop the dashboard from working.</p>
      <h2>Contact</h2>
      <p>Questions: <a href="mailto:support@atkinsmedia.io">support@atkinsmedia.io</a>.</p>
    </LegalLayout>
  );
}
